import React from 'react'
import '../Styles/Section8.css'

export default function Section8() {
  return (
    <div className='section8'>
      <iframe className='map' src="https://www.google.com/maps/embed/v1/place?q=Maharishi+Dayanand+Inter+College,+Navin+Nagar,+Saharanpur,+Uttar+Pradesh,+India&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" title='Our office' loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      <img className='sec8image' src="./images/sec8image.png" alt="" />
    </div>
  )
}


